export default __webpack_public_path__ + "locales/hy-AM/JavascriptSdk.json?hash=11669086099c04bd5fdcc2c37edf7ecc";